import axios from '../config/api'
import Vue from 'vue'

const state = () => ({
  submit: {
    data: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
  },
})

// getters
const getters = {
  data: state => state.submit.data,
  isLoading: state => state.submit.isLoading,
  isSuccess: state => state.submit.isSuccess,
  isError: state => state.submit.isError,
}

// actions
const actions = {
  async shopeePayRequest({ commit }, uuid) {
    commit('submitRequest')

    const transformedPayload = {
      order_id: uuid,
      html: 1,
    }

    await axios
      .post('/payments/shopeepay', transformedPayload)
      .then(res => {
        const transformedData = {
          qrCode: res.data.data.qr_code,
          storeName: res.data.data.store_name,
          expiryTime: res.data.data.expiry_time,
          amount: res.data.data.amount,
          orderCode: res.data.data.ref_id,
        }

        commit('submitRequestSuccess', transformedData)
      })
      .catch(error => {
        commit('submitRequestFailure', error.response.data.message)

        let message = error.response.data.message
          ? error.response.data.message
          : 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'

        Vue.$toast.error(message, {
          duration: 5000,
          position: 'top',
        })
      })
  },
  reset({ commit }) {
    commit('submitRequestReset')
  },
}

const mutations = {
  submitRequest(state) {
    state.submit.isLoading = true
    state.submit.isError = false
    state.submit.isSuccess = false
    state.submit.errorMessage = ''
  },

  submitRequestSuccess(state, event) {
    state.submit.data = event
    state.submit.isLoading = false
    state.submit.isSuccess = true
  },

  submitRequestFailure(state, errorMessage) {
    state.submit.isLoading = false
    state.submit.isError = true
    state.submit.errorMessage =
      errorMessage || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
  },

  submitRequestReset(state) {
    state.submit.data = null
    state.submit.isLoading = false
    state.submit.isSuccess = false
    state.submit.isError = false
    state.submit.errorMessage = ''
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
